import { EXPERIMENTS_SCOPE } from '../../config/constants';
import Experiments from '@wix/wix-experiments';
import {
  getWixCodeGalleryItems,
  getWixCodeAlbumData,
} from '../../services/wixCodeDataNormalizer';
import { getData } from '../../services/dataService';
import templatesData from '../../config/templatesData';

let resultData = {};
let modifiedOn = new Date().getTime();
let refreshCallback = () => {};

function getLocale({ wixCodeApi }) {
  return wixCodeApi.window.locale || 'en';
}

function isMobile({ wixCodeApi }) {
  return wixCodeApi.window.formFactor === 'Mobile';
}

async function getExperimentsByScope(scope) {
  const experiments = new Experiments({
    scope,
  });
  await experiments.ready();
  return experiments.all();
}

const isTemplate = ({ baseUrl, query }) => {
  return (
    baseUrl.indexOf('exposure4.wixsite.com/website-') > -1 ||
    baseUrl.indexOf('wix.com/exposure4/website-') > -1 ||
    !!query.skipItems
  );
};

export const refreshSets = data => {
  modifiedOn = new Date().getTime();
  if (data && data.albumData) {
    const albumData = data.albumData || resultData.albumData;
    const sets = data.sets || resultData.sets;
    resultData.sets = sets && getWixCodeGalleryItems(sets, albumData);
    resultData.albumData = getWixCodeAlbumData(albumData, resultData.sets);
    refreshCallback(resultData);
  }
};

const goToPage = controllerConfig => path => {
  try {
    controllerConfig.wixCodeApi.location.to(path);
  } catch (e) {
    console.error('albums uou, error navigating', e);
  }
};

export async function createAppController(controllerConfig) {
  const { appParams, setProps, platformAPIs, wixCodeApi } = controllerConfig;
  const { instanceId, instance } = appParams;
  const { window } = wixCodeApi;
  const { viewMode } = window;
  const isPreview = viewMode === 'Preview';
  const state = isPreview ? 'SAVED' : 'PUBLISHED';
  const locale = getLocale(controllerConfig);
  const mobile = isMobile(controllerConfig);
  const experiments = await getExperimentsByScope(EXPERIMENTS_SCOPE);
  let fedopsLogger;

  try {
    if (platformAPIs) {
      const fedOpsLoggerFactory = platformAPIs.fedOpsLoggerFactory;
      fedopsLogger = fedOpsLoggerFactory.getLoggerForWidget({
        appId: 'd3e94e97-1218-4796-aa05-c9a6c68ecb16',
        widgetId: '1078f2d8-ae0e-4dd1-a0ef-105c44b16066',
      });
      fedopsLogger.appLoadStarted();
    }
  } catch (e) {
    console.error('Cannot create fedops logger', e);
  }

  let resultsPromise;
  if (isTemplate(wixCodeApi.location)) {
    const { albumData, sets } = templatesData;
    const wixCodeAlbumData = getWixCodeAlbumData(albumData, sets);
    resultsPromise = Promise.resolve({ albumData: wixCodeAlbumData, sets });
  } else {
    resultsPromise = getData(instanceId, state).then(result => {
      resultData = result;
      try {
        const albumName = result.albumData.albumName;
        if(wixCodeApi.location.prefix === 'set' && wixCodeApi.location.path.length > 0) {
          const setId = wixCodeApi.location.path[0];
          const currentSet = result.sets.find(x => x.id === setId);
          const pageTitleString =  currentSet.name + (albumName && currentSet.name ? ' | ' : '') + albumName
          wixCodeApi.seo.setTitle(pageTitleString);
        } else if (!wixCodeApi.location.prefix && wixCodeApi.location.path[0] === 'sets') {
          wixCodeApi.seo.setTitle('Sets | ' + albumName);
        } else if (!wixCodeApi.location.prefix && wixCodeApi.location.path.length === 0) {
          wixCodeApi.seo.setTitle(albumName);
        }
      } catch(e) {
        console.log('Failed to set title seo')
      }
      return resultData;
    });
  }
  const reportAppLoaded = fedopsLogger
    ? () => fedopsLogger.appLoaded()
    : () => {};

  return {
    async pageReady() {
      setProps({
        name: 'World',
        cssBaseUrl: appParams.baseUrls.staticsBaseUrl,
        locale,
        mobile,
        experiments,
        instance,
        refreshSets,
        reportAppLoaded,
        goToPage: goToPage(controllerConfig),
      });
    },
    exports: () => ({
      shouldRefresh: _modifiedOn => {
        return {
          modifiedOn,
          changed: modifiedOn !== _modifiedOn,
        };
      },
      onRefreshHappened: callback => {
        refreshCallback = callback;
      },
      onReady: () => {
        return resultsPromise;
      },
      reportPageLoaded: setId => {
        setProps({
          currentPage: setId || '',
          time: new Date().getTime(),
          name: 'World',
          cssBaseUrl: appParams.baseUrls.staticsBaseUrl,
          locale,
          mobile,
          experiments,
          instance,
          refreshSets,
          reportAppLoaded,
          goToPage: goToPage(controllerConfig),
        });
      },
    }),
  };
}
